<template>
  <div class="bottom-pane-sizer">
    <div class="bottom-pane-sizer__button" :class="{'bottom-pane-sizer__button--active': isActive('small')}" @click="setSizeTo('small')"><div class="bottom-pane-sizer__small"></div></div>
    <div class="bottom-pane-sizer__button" :class="{'bottom-pane-sizer__button--active': isActive('medium')}" @click="setSizeTo('medium')"><div class="bottom-pane-sizer__medium"></div></div>
    <div class="bottom-pane-sizer__button" :class="{'bottom-pane-sizer__button--active': isActive('large')}" @click="setSizeTo('large')"><div class="bottom-pane-sizer__large"></div></div>
  </div>
</template>

<script>
  export default {
    props: {
      currentSize: {
        type: String,
        required: true
      }
    },
    methods: {
      isActive (size) {
        return size === this.currentSize
      },
      setSizeTo (size) {
        this.$emit('new-size', size)
      }
    }
  }
</script>

<style lang='scss'>
  .bottom-pane-sizer {
    display: flex;
    flex: 0 0 auto;
    width: 140px;

    &__button {
      @include naked-btn;
      display: flex;
      align-items: flex-end;
      width: rem(40);
      height: rem(20);
      margin: 0 rem(10) 0 0;
      padding: 0;
      cursor: pointer;

      &:hover, &--active {
        div {
          background: color(grays, light);
        }
      }
    }

    &__small, &__medium, &__large {
      flex: 1 0 auto;
      background: color(blue-black, dark);
    }

    &__small {
      height: rem(4);
    }

    &__medium {
      height: rem(10);
    }

    &__large {
      height: rem(20);
    }
  }
</style>



// WEBPACK FOOTER //
// BottomPaneSizer.vue?4ab908d0